import { render, staticRenderFns } from "./long.vue?vue&type=template&id=29bdeca9&"
import script from "./long.vue?vue&type=script&lang=js&"
export * from "./long.vue?vue&type=script&lang=js&"
import style0 from "./long.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports